export const createTemplateRequest = async (payload, entity) => {
  if (!['template', 'draft'].includes(entity)) {
    throw new Error('Invalid entity type. Use "template" or "draft".');
  }

  const url =
    entity === 'template'
      ? '/app/configuration/create_vacancy_request_template'
      : '/app/configuration/create_draft_request_template';

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  return response.json();
};

export const updateTemplateRequest = async (payload, entity) => {
  if (!['template', 'draft'].includes(entity)) {
    throw new Error('Invalid entity type. Use "template" or "draft".');
  }

  const templateId = payload?.id;
  if (!templateId) {
    throw new Error('Template ID is required for update operation');
  }

  const url =
    entity === 'template'
      ? `/app/configuration/update_vacancy_request_template/${templateId}`
      : `/app/configuration/update_draft_request_template/${templateId}`;

  delete payload.id;
  const response = await fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  return response.json();
};

export const getTemplateRequestData = async (templateId) => {
  const response = await fetch(`/app/configuration/get_vacancy_request_template/${templateId}`);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
